const categories = ['Action', 'Drama', 'Biography', 'History', 'Horror', 'Kids', 'Learning', 'Science Fiction'];
export default categories;
